<template>
    <div class="sports_result" v-if="itemDetail">
        <div class="header">
            <div class="avatar">
                <van-image :src="itemDetail.myinfo.avatar"></van-image>
            </div>
            <div class="nickname">
                {{itemDetail.myinfo.name ? itemDetail.myinfo.name : itemDetail.myinfo.nickname}}
            </div>
        </div>

        <div class="body">
            <div class="header">
                恭喜您!
            </div>

            <div class="body">
                <mVideo :videoUrl="myinfo.mediaurl" height="3.5rem" :mediaType="itemDetail.media_type" v-if="+itemDetail.type!==5"></mVideo>
                <div class="desc">
                    您已成功参加
                    <p style="font-weight: bold;">{{ itemDetail.title }}</p>
                    <p v-if="+myinfo.state===1">
                        <template v-if=" +itemDetail.type!==5">
                             系统得分:{{ myinfo.score }}
                        </template>
                    </p>
                    <p v-else-if="+itemDetail.type===4 || +itemDetail.type===5">请耐心等待管理员审核</p>
                    <p v-else-if="+myinfo.state===3 || myinfo.state*1===4">视频审核不通过</p>
                    <!-- <p v-else>稍后请回到该页面查看分数</p> -->
                </div>
            </div>
        </div>

        <Popup v-model="certShow">
            <van-image
                    :src="itemDetail.myinfo.cert"
                    fit="cover"
                    width="5rem"
                    style="display:flex;align-items: center;justify-content: center;"
            ></van-image>

            <div style="font-size:12px;text-align: center;margin:.2rem 0;">
                长按保存证书
            </div>
        </Popup>

        <div class="footer" v-if="itemDetail.myinfo.cert && +itemDetail.type!==5">
            <Button
                    :disabled="!itemDetail.myinfo.cert"
                    @click="certShow = true"
                    round
                    type="primary"
                    block
                    :color="buttonColor"
            >下载证书
            </Button
            >
        </div>
    </div>
    <Empty v-else description="数据加载中"/>
</template>

<style lang="less" scoped>
    @import './index.less';
</style>

<script>
    import mVideo from '@/components/mVideo/index';
    import {mapGetters} from 'vuex';
    import {Empty, Panel, Cell, Button, CellGroup, Image, Popup} from 'vant';

    export default {
        computed: {
        },
        components: {
            Empty,
            Panel,
            Cell,
            Button,
            CellGroup,
            VanImage: Image,
            mVideo,
            Popup,
        },
        data() {
            return {
                detail: '',
                itemDetail: '',
                joinList: [],
                certShow: false,
                myinfo: {},
                item_sub_id: '',
                acid: ''
            };
        },
        methods: {
            submit: function (e) {
                this.$dialog
                    .confirm({
                        title: '提示',
                        confirmButtonText: '确定提交',
                        message: '信息提交后不可修改,确定提交?',
                        showCancelButton: true,
                    })
                    .then(() => {
                        this.$api.sports
                            .submitCompare({cpgid: this.item_sub_id, registerInfo: e})
                            .then((res) => {
                                if (+res.status === 200) {
                                    this.$router.replace({
                                        name: 'result',
                                        params: {type: 'success'},
                                    });
                                }
                            });
                        // on confirm
                    })
                    .catch(() => {
                        // on cancel
                    });

                console.log(e);
            },
            init: function () {
                this.$toast.loading({
                    duration: 0,
                });
                let params = {cpgid: this.item_sub_id};
                Promise.all([
                    this.$api.sports.compareRank(params),
                    this.$api.sports.myRanks({acid:this.item_sub_id})
                ]).then((res) => {
                    this.joinList = res[0]['list'];
                    delete res[0]['data']['list'];
                    if (res[0]['data']['registerform']) {
                        try {
                            res[0]['data']['registerform'] = JSON.parse(
                                res[0]['data']['registerform']
                            );
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    this.itemDetail = res[0]['data'];
                    this.myinfo = res[1]['data']['list'][0];
                    this.$toast.clear();
                });
            },
        },
        mounted() {
            this.item_sub_id = this.$route.params.item_sub_id
            this.acid = this.$route.params.acid
            this.init();
        },
    };
</script>
